import { Text, styled, spacing } from '@thg-commerce/gravity-theme'

export const iconWrapperStyle = {
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: spacing(1),
}

export const infoBoxesFlexStyle = {
  display: 'flex',
  alignItems: 'center',
}

export const Paragraph = styled.p`
  ${Text('small', 'default')}
  margin-top: ${spacing(1)};
`

export const Title = styled.h2`
  ${Text('bodyText', 'alternate')}
`

export const InfoBoxesWrapper = styled.div`
  border: solid 1px ${(props) => `${props.theme.colors.palette.greys.light};`};

  div:last-child {
    border-bottom: none;
  }
`

export const InfoBoxesItemWrapper = styled.div`
  border-bottom: solid 1px
    ${(props) => `${props.theme.colors.palette.greys.light}`};
  padding: ${spacing(2)};
`
